var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCnVLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270 82",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Conquest and Virtue header wordmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A balanced three-line serif wordmark, without an emblem.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ead9ad",
    fontFamily: "Georgia, 'Times New Roman', serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 27,
    fontSize: 21.5,
    letterSpacing: 4.2
  }, "CONQUEST"), /*#__PURE__*/React.createElement("path", {
    d: "M48 42 H111 M159 42 H222",
    fill: "none",
    stroke: "#cbb477",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 42 l4 -2.2 l4 2.2 l-4 2.2 Z M151 42 l4 -2.2 l4 2.2 l-4 2.2 Z",
    fill: "#cbb477"
  }), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 45.2,
    fontSize: 9.2,
    letterSpacing: 0.45
  }, "AND"), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 70,
    fontSize: 22,
    letterSpacing: 5.3
  }, "VIRTUE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnVLogoHeader);
export default __webpack_public_path__ + "static/media/CnVLogoHeader.352c7181a62873c9953f3ef33a30569b.svg";
export { ForwardRef as ReactComponent };